import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { pluginPlatformApi, type PublisherProfile } from '../../api/pluginplatform';

export function PublisherDashboardPage() {
  const [publishers, setPublishers] = useState<PublisherProfile[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void pluginPlatformApi.publishers().then((r) => setPublishers(r.publishers)).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/plugins" className="text-sm text-blue-600 hover:underline">← Plugin Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Publisher Dashboard</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-3">
        {publishers.map((p) => (
          <div key={p.id} className="rounded-xl border p-4 dark:border-slate-700">
            <p className="font-medium">{p.name} {p.verified && <span className="text-xs text-green-600">Verified</span>}</p>
            <p className="text-sm text-slate-500">{p.company} · {p.plugin_count} plugins</p>
            {p.website && <a href={p.website} className="text-sm text-blue-600 hover:underline">{p.website}</a>}
          </div>
        ))}
      </div>
    </div>
  );
}
